<script setup lang="ts">
import { computed } from 'vue';

import GenericModal from '~/components/shared/GenericModal.vue';

const props = defineProps<{
  show: boolean;
}>();

const emit = defineEmits<{
  cancel: [];
  confirm: [];
}>();

const isOpen = computed({
  get: () => props.show,
  set: (value: boolean) => {
    if (!value) emit('cancel');
  },
});
</script>

<template>
  <GenericModal
    v-model="isOpen"
    title="Editar incentivo ativo"
    primary-button-text="Continuar"
    secondary-button-text="Cancelar"
    @primary-action="emit('confirm')"
    @secondary-action="emit('cancel')"
  >
    <p class="modal-summary">
      Editar este incentivo o moverá de volta para "Em Análise". Deseja continuar?
    </p>
  </GenericModal>
</template>

<style scoped lang="scss">
.modal-summary {
  margin: 0;
  color: #374151;
  font-size: 14px;
  line-height: 1.5;
}
</style>
